import React from 'react';
import UIComponent from './ui_component.js';
import { withStyles } from 'material-ui/styles';
import {FormControlLabel} from 'material-ui/Form';


const styles = [];

class UIFormControlLabel extends UIComponent {
  constructor() {
    super();
    this.state = {
    }
  }

  getDefaults(){
    const defaults = {
      className : '',      
      control: '',
      label: '',
    }    
    return defaults;
  }
  
  componentDidMount() {

  }
  
  render() {
    return (
      <FormControlLabel className={this.state.className} control={this.state.control} label={this.props.label}/>
    );
  }
}

export default withStyles(styles)(UIFormControlLabel);


// WEBPACK FOOTER //
// ./src/core/ui/form_control_label.js